// 分子动力学
import React, { useEffect, useRef, useState } from 'react';
// import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import { RootObject, CooperationCaseTabsList, SideImgList, PartnersList } from '../../type';
import './style.less';
import { Button, Carousel } from 'antd';

const MolecularDynamics = (props: RootObject['molecularDynamics']) => {
    const [currentIndex, setCurrentIndex] = useState(0);
    // 获取合作伙伴图片数量
    // const [partnersImgList, setPartnersImgList] = useState<number>(
    //     props?.CooperationCaseTabsList[0]?.CooperationCaseTabsContent[0]?.partners?.partnersList.length > 5
    //         ? props?.CooperationCaseTabsList[0]?.CooperationCaseTabsContent[0]?.partners?.partnersList.length
    //         : 0
    // );
    // const [partnersImgList, setPartnersImgList] = useState<number>(10);
    // const [count, setCount] = useState(0);

    const tabRef = useRef<HTMLDivElement>(null);
    const urRef = useRef<HTMLDivElement>(null);
    const contentRef = useRef<HTMLDivElement>(null);
    // 左箭头
    // const leftArrow = () => {
    //     if (Math.abs(count) === partnersImgList) {
    //         // count = 0;
    //         setCount(0);
    //         return;
    //     } else {
    //         setCount(count - 1);
    //     }
    // };
    // 右箭头
    // const rightArrow = () => {
    //     if (Math.abs(count) === partnersImgList) {
    //         // count = 0;
    //         setCount(0);
    //         return;
    //     } else {
    //         setCount(count + 1);
    //     }
    // };
    useEffect(() => {
        if (tabRef.current && contentRef.current) {
            tabRef.current.style.left = `${132 * currentIndex}px`;
            contentRef.current.style.right = `${1200 * currentIndex}px`;
        }
    }, [currentIndex]);
    // useEffect(() => {
    //     if (urRef.current && Math.abs(count) !== partnersImgList) {
    //         console.log(urRef.current);

    //         urRef.current.style.left = `${227 * count}px`;
    //     } else {
    //         setCount(0);
    //     }
    // }, [count, partnersImgList]);

    // const contentStyle = {
    //     height: '280px',
    //     color: '#fff',
    //     lineHeight: '160px',
    //     background: '#fff'
    // };

    // console.log(partnersImgList);
    return (
        <div className="molecular_dynamics">
            {/* <div className="molecular_dynamics_title">
      典型合作案例
      </div> */}
            <div className="molecular_dynamics_sub_title">{props.CooperationCaseContent ?? ''}</div>
            {/* table */}
            <div className="molecular_dynamics_content">
                <div className="molecular_dynamics_back_img" style={{ background: `url(${props.backImg})` }}></div>

                {/* tablet头部 */}
                {props.CooperationCaseTabsList.length > 1 ? (
                    <div className="molecular_dynamics-tab">
                        {props.CooperationCaseTabsList.map((item: CooperationCaseTabsList, index: number) => (
                            <div
                                className={classNames('molecular_dynamics-tab-item', {})}
                                key={index}
                                onClick={() => {
                                    setCurrentIndex(index);
                                    // setPartnersImgList(
                                    //     props?.CooperationCaseTabsList[0]?.CooperationCaseTabsContent[0]?.partners
                                    //         ?.partnersList.length > 5
                                    //         ? props?.CooperationCaseTabsList[0]?.CooperationCaseTabsContent[0]?.partners
                                    //               ?.partnersList.length
                                    //         : 0
                                    // );
                                }}
                            >
                                <div
                                    className={classNames('molecular_dynamics-tab-item-title', {
                                        'current-tab-item': index === currentIndex
                                    })}
                                >
                                    {item.title}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="molecular_dynamics-tab move_title">
                        {props.CooperationCaseTabsList.map((item: CooperationCaseTabsList, index: number) => (
                            <div
                                className={classNames('molecular_dynamics-tab-item', {})}
                                key={index}
                                onClick={() => {
                                    setCurrentIndex(index);
                                    // setPartnersImgList(item.CooperationCaseTabsContent[0].partners.partnersList.length);
                                }}
                            >
                                <div
                                    className={classNames('molecular_dynamics-tab-item-title', {
                                        'current-tab-item': index === currentIndex
                                    })}
                                >
                                    {item.title}
                                </div>
                            </div>
                        ))}
                    </div>
                )}

                {/* 滚动条 */}
                <div className="molecular_dynamics-vertical-scroll">
                    {props.CooperationCaseTabsList.length > 1 ? (
                        <div className="current-selected-tab" ref={tabRef} />
                    ) : (
                        <div className="current-selected-tab move_scrool" ref={tabRef} />
                    )}
                </div>
                {/* 内容 */}
                <div className="molecular_dynamics-content-wrapper">
                    <div className="molecular_dynamics-content" ref={contentRef}>
                        {props.CooperationCaseTabsList.map((item: CooperationCaseTabsList, index: number) => (
                            <div className="molecular_dynamics-content-item" key={index}>
                                {/* 头部 */}
                                <div className="item_header">
                                    {/* 左边文案信息 */}
                                    <div className="item_header_info">
                                        <div className="header_info_title">
                                            {item.CooperationCaseTabsContent[0].title ?? ''}
                                        </div>
                                        <div className="header_info_content">
                                            {item.CooperationCaseTabsContent[0].headerContent ?? ''}
                                        </div>
                                        <img
                                            className="header_info_center_img"
                                            src={item.CooperationCaseTabsContent[0].centerImg}
                                            alt=""
                                        />
                                        <div className="header_info_bottom_content">
                                            {item.CooperationCaseTabsContent[0].bottomContent ?? ''}
                                        </div>
                                        <Button   className="header_info_content_btn" type="primary">
                                        <a
                                          
                                            href={item.CooperationCaseTabsContent[0].detailLink}
                                        >
                                            {' '}
                                            {item.CooperationCaseTabsContent[0].jumpTitle ?? ''}
                                        </a>
                                        </Button>
                                    </div>
                                    {/* 侧右边Img */}
                                    <div className="item_header_side">
                                        {/* <Carousel autoplay={true} className="shuffling">
                                            {item?.CooperationCaseTabsContent[0]?.sideImgList.map(
                                                (value: SideImgList, index: number) => {
                                                    return (
                                                        <img
                                                            src={value.partnerList}
                                                            key={index}
                                                            alt={value.partnerList}
                                                        ></img>
                                                    );
                                                }
                                            )}
                                        </Carousel> */}
                                        <Carousel autoplay={true}>
                                            {item?.CooperationCaseTabsContent[0]?.sideImgList.map(
                                                (value: SideImgList, index: number) => {
                                                    return (
                                                        <div key={index}>
                                                            <div 
                                                            // style={contentStyle}
                                                             className="content_style"
                                                             >
                                                                <img
                                                                    src={value.partnerList}
                                                                    key={index}
                                                                    alt=""
                                                                />
                                                            </div>
                                                        </div>
                                                    );
                                                }
                                            )}
                                        </Carousel>
                                    </div>
                                </div>
                                {/* 底部 */}
                                <div className="item_bottom">
                                    <div className="bottom_title">
                                        {item.CooperationCaseTabsContent[0].partners.detailLink ?? ''}
                                    </div>
                                    <div className="bottom_box">
                                        {/* 左箭头 */}
                                        {/* <div className="left_arrow" onClick={() => leftArrow()}>
                                            <LeftOutlined size={20} color="#ecedef" />
                                        </div> */}
                                        {/* 右箭头 */}
                                        {/* <div className="right_arrow" onClick={() => rightArrow()}>
                                            <RightOutlined size={20} color="#ecedef" />
                                        </div> */}
                                        <div className="bottom_img_wrapper">
                                            {/* <div className="img_wrapper"> */}
                                            <div className="bottom_img_ul" ref={urRef}>
                                                {item.CooperationCaseTabsContent[0].partners.partnersList.map(
                                                    (imgValue: PartnersList, index: number) => {
                                                        return (
                                                            <img
                                                                src={imgValue.partnerList}
                                                                className="bottom_img_li"
                                                                key={index}
                                                                alt=""
                                                            ></img>
                                                        );
                                                    }
                                                )}
                                                {/* </div> */}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MolecularDynamics;
